import {
  AdSystemCampaignStateQueryT,
  AdSystemStateT,
  AdSystemT,
  MetaAdsWizardStepT,
  WizardStepT,
} from "../graphql/generated/graphql";

export const getAdSystemCampaignState = (data?: AdSystemCampaignStateQueryT, adSystem?: AdSystemT) => {
  const adsSetting =
    adSystem === AdSystemT.GoogleAdsT ? data?.organization?.googleAdsSetting : data?.organization?.metaAdsSetting;

  const wizardFinished =
    adsSetting?.wizardStep === WizardStepT.DashboardT || adsSetting?.wizardStep === MetaAdsWizardStepT.DashboardT;

  if (adsSetting?.state === null || adsSetting?.state === undefined) {
    // A null/unknown state means the campaign was previously started but its
    // state got lost (see DOT-10390). If the wizard is finished the campaign is
    // effectively stopped; otherwise it has genuinely not been started yet.
    return wizardFinished ? "paused" : "wizard";
  }
  if (adsSetting?.state === AdSystemStateT.PausedT) {
    return "paused";
  }
  if (adsSetting?.state === AdSystemStateT.NoCreditT) {
    return "no_credit";
  }
  if (adsSetting?.state === AdSystemStateT.NoProductsT) {
    return "no_products";
  }
  if (adsSetting?.state === AdSystemStateT.AccountSuspendedT) {
    return "account_suspended";
  }
  if (adsSetting?.state === AdSystemStateT.WizardT) {
    return "wizard";
  }

  // Handle ACTIVE state
  if (adsSetting?.state === AdSystemStateT.ActiveT) {
    if (data?.organization?.summaryStats?.impressions === 0) {
      return "activating";
    }

    const hasOptimizations = (data?.organization?.campaignOptimizations?.length ?? 0) > 0;
    if (hasOptimizations && adsSetting?.optimizationsEnabled) {
      return "active_optimizing";
    }
    return "active";
  }

  return "wizard";
};
